var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccupationalTherapist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.11 139.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff160a;}.cls-2,.cls-3{opacity:0.2;}.cls-3{fill:#fff;}.cls-4,.cls-5{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:8px;}.cls-5{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.11,70a69.56,69.56,0,1,0-69.57,69.58A69.56,69.56,0,0,0,139.11,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.54,128.76A69.56,69.56,0,0,1,.19,64.36C.07,66.07,0,67.8,0,69.54a69.56,69.56,0,1,0,139.11,0c0-1.74-.06-3.47-.19-5.18A69.59,69.59,0,0,1,69.54,128.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.54,10.35a69.58,69.58,0,0,1,69.38,64.37c.13-1.71.19-3.44.19-5.18A69.56,69.56,0,0,0,0,69.54c0,1.74.07,3.47.19,5.18A69.55,69.55,0,0,1,69.54,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.39,69.82,91.9,45.14a7.05,7.05,0,0,1,9.84-1.67h0a7.05,7.05,0,0,1,1.67,9.84L85.9,78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.36,53.47,68.78,28.73a7.05,7.05,0,0,1,9.84-1.67h0a7.05,7.05,0,0,1,1.67,9.84L62.78,61.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.9,78,97.74,61.31a6.78,6.78,0,0,1,9.49-1.38l.16.11a6.78,6.78,0,0,1,1.83,9.42L87.28,100"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.15,61.26,85.83,29.31a7.11,7.11,0,0,1,9.73-1.52h0a7.21,7.21,0,0,1,1.5,10.08L74.39,69.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.57,99.78c-15.3,20.24-36.68,16.37-51.39,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.48,76.08c-1.49-6.26-2-5.85-1.14-11.16,1.34-8.39.07-4.84,3.12-12.59,1.88-4.79,8-7.6.41-13.14C46,34.86,38,50.26,36.44,57.53c-1.39,6.54-16.71,27.13.08,44.48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupationalTherapist);
export default __webpack_public_path__ + "static/media/OccupationalTherapist.c2873f67fe11c1b0c1ab34d915caec39.svg";
export { ForwardRef as ReactComponent };